import { DatePicker, Form } from 'antd';
import { map, orderBy } from 'lodash';
import { useListEmployees } from '../../utils/api-hooks/employee.hook';
import EmployeeSelectorComponent from '../../shared/employee-selector/employee-selector.component';
import { FunctionInfoComponent } from '../../shared/function-info.component';
import { Ref, useImperativeHandle } from 'react';
import { FormInstance } from 'antd/lib';

interface Props {
  formRef: Ref<FormInstance>;
}

export function ExportPayrollForm(props: Props) {
  const { formRef } = props;
  const [form] = Form.useForm();
  const {
    data: { data: employees = [] } = {},
    isLoading,
    isFetching,
  } = useListEmployees();

  useImperativeHandle(formRef, () => form, [form]);

  return (
    <Form form={form} preserve={false}>
      <Form.Item
        name="month"
        label="月份"
        rules={[{ required: true, message: 'Please select a month' }]}
      >
        <DatePicker.MonthPicker />
      </Form.Item>
      <EmployeeSelectorComponent
        loading={isLoading || isFetching}
        label={
          <div className="flex items-center gap-2">
            <span>員工</span>
            <FunctionInfoComponent
              title={
                <ol>
                  <li>若不選擇員工，將會匯出所有員工的薪資單。</li>
                  <li>
                    若選中的員工在該期間沒有排任何班，系統將會自動略過該員工。
                  </li>
                </ol>
              }
            />
          </div>
        }
        options={map(
          orderBy(employees, ['onBoardingTime'], ['asc']),
          (employee) => ({
            value: employee.id,
            label: `${employee.idNumber ? `${employee.idNumber} - ` : ''}${employee.name}`,
          })
        )}
        multiple
      />
    </Form>
  );
}
